import { render, staticRenderFns } from "./TextPathImportModal.vue?vue&type=template&id=a2a3dbb0&scoped=true"
import script from "./TextPathImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextPathImportModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextPathImportModal.vue?vue&type=style&index=0&id=a2a3dbb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a3dbb0",
  null
  
)

export default component.exports